import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { ROUTES, STORAGE_KEY } from '@/constants';
import { type LayoutType, useGlobalStore } from '@/stores/GlobalStore';

/**
 * layoutType 관련 side effect를 처리하는 훅
 * GlobalLayout에서 한 번만 호출해야 함
 */
export const useOverrideLayoutTypeEffect = () => {
  const pathname = usePathname();
  const currentRouteType = useGlobalStore((state) => state.currentRouteType);
  const setOverrideLayoutType = useGlobalStore(
    (state) => state.setOverrideLayoutType,
  );

  //* 로그인 페이지에서 회원가입 관련 페이지를 위한 layoutType을 정의
  useEffect(() => {
    if (pathname !== ROUTES.LOGIN.pathname) return;

    if (currentRouteType === 'DONATION') {
      sessionStorage.setItem(STORAGE_KEY.AUTH_LAYOUT_TYPE, 'donation');
    } else {
      sessionStorage.setItem(STORAGE_KEY.AUTH_LAYOUT_TYPE, 'wello');
    }
  }, [pathname, currentRouteType]);

  //* 아래 페이지에서는 override된 layoutType을 사용
  //* currentRouteType으로 wello인지 donation인지를 모르는 경우에 활용
  useEffect(() => {
    if (
      pathname !== ROUTES.EASY_CERTIFICATION_CALLBACK.pathname &&
      pathname !== ROUTES.JOIN_COMPLETE.pathname
    ) {
      setOverrideLayoutType(null); //* 위 페이지에 해당하지 않는 경우에는 초기화

      return;
    }

    const authLayoutType = sessionStorage.getItem(
      STORAGE_KEY.AUTH_LAYOUT_TYPE,
    ) as LayoutType | null;

    if (authLayoutType) {
      setOverrideLayoutType(authLayoutType);
    }
  }, [pathname, setOverrideLayoutType]);
};
